export default __webpack_public_path__ + "static/media/google-btn.81fb20a2.svg";